export default [
    {
        path: '/homepage',
        name: 'homepage',
        component: () => import('../views/HomePage.vue'),
        meta: {
            fixedContent: false,
            accountSelect: {
                disabled: false,
                showParentAccounts: true,
            },
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
];
